import axios from "axios";
import { Baseurl } from "../baseurl";
import { toast } from "react-toastify";

export const handleDeleteCase = async (id) => {
  const url = `${Baseurl}/api/cases/deleteCase/${id}`;
  const response = await axios.delete(url);
  if (response.data.success) {
    toast.info(`${response.data.message}`);
  }
};
